import React, { useState } from 'react'
import { TextField, RenderCurrencyFormatTextField, Button } from '@components/atoms'
import {
	Modal,
	FormControlLabel,
	Switch,
	Box,
	Typography,
	IconButton,
} from '@mui/material'

import { useDispatch } from 'react-redux'
import { productActions } from '@redux/store/index'
import CloseIcon from '@mui/icons-material/Close'
import { css } from '@emotion/react'

interface ProductRegistrationModalProps {
	open: boolean
	onClose: () => void
}

export const ProductRegistrationModal: React.FC<ProductRegistrationModalProps> = ({
	open,
	onClose,
}) => {
	const dispatch = useDispatch()
	const [name, setName] = useState('')
	const [code, setCode] = useState('')
	const [usd, setUsd] = useState<number>(0)
	const [index, setIndex] = useState('')
	const [useYn, setUseYn] = useState(true)
	const [errors, setErrors] = useState<{ [key: string]: string }>({})

	const validateForm = () => {
		const newErrors: { [key: string]: string } = {}
		if (!name.trim()) newErrors.name = '제품명을 입력해주세요.'
		if (usd === 0) newErrors.usd = '가격을 입력해주세요.'
		if (isNaN(Number(usd))) newErrors.usd = '유효한 가격을 입력해주세요.'
		if (!index.trim()) newErrors.index = '인덱스를 입력해주세요.'
		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleRegister = () => {
		if (validateForm()) {
			dispatch(productActions.REGISTER_PRODUCT({ name, code, usd, index, useYn }))
			handleClose()
		}
	}

	const handleClose = () => {
		setName('')
		setCode('')
		setUsd(0)
		setIndex('')
		setUseYn(true)
		setErrors({})
		onClose()
	}

	return (
		<Modal open={open} onClose={handleClose}>
			<Box component="div" sx={styles.modalContent}>
				<IconButton onClick={handleClose} sx={styles.closeButton} aria-label="close">
					<CloseIcon />
				</IconButton>
				<Typography variant="h5" component="h2" sx={styles.title}>
					제품 등록
				</Typography>
				<TextField
					label="제품명"
					value={name}
					onChange={e => setName(e.target.value)}
					fullWidth
					margin="normal"
					error={!!errors.name}
					helperText={errors.name}
				/>
				<TextField
					label="제품코드"
					value={code}
					onChange={e => setCode(e.target.value)}
					fullWidth
					margin="normal"
					error={!!errors.name}
					helperText={errors.name}
				/>
				<TextField
					label="가격 (USD)"
					value={usd}
					onChange={e => setUsd(Number(e.target.value))}
					fullWidth
					margin="normal"
					error={!!errors.usd}
					helperText={errors.usd}
					InputProps={{
						inputComponent: RenderCurrencyFormatTextField,
					}}
				/>
				<TextField
					label="인덱스"
					value={index}
					onChange={e => setIndex(e.target.value)}
					fullWidth
					margin="normal"
					error={!!errors.index}
					helperText={errors.index}
				/>
				<FormControlLabel
					control={
						<Switch
							checked={useYn}
							onChange={e => setUseYn(e.target.checked)}
							color="primary"
						/>
					}
					label="사용 여부"
					sx={styles.switch}
				/>
				<Button
					onClick={handleRegister}
					variant="contained"
					color="primary"
					fullWidth
					sx={styles.button}
				>
					등록
				</Button>
			</Box>
		</Modal>
	)
}

const styles = {
	modalContent: css`
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 400px;
		background-color: white;
		box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
			0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
		padding: 32px;
		border-radius: 8px;
	`,
	closeButton: css`
		position: absolute;
		right: 8px;
		top: 8px;
	`,
	title: css`
		margin-bottom: 16px;
	`,
	switch: css`
		margin-top: 16px;
		margin-bottom: 24px;
	`,
	button: css`
		margin-top: 16px;
	`,
}
